/**
 * Every tunable weight/coefficient used by the scoring engine lives here so
 * the formulas in src/engine/scoring stay readable and so weights can be
 * retuned without hunting through module logic. Values are defaults based
 * on the Phase 1 spec's intent (DOM + inventory + sale-to-list as the core
 * "temperature" signal); revisit once enough real snapshot history exists
 * to backtest against actual outcomes.
 */
export const scoringWeights = {
  hotCold: {
    domZWeight: -0.3, // lower DOM => hotter, hence negative coefficient on raw DOM z-score
    moiZWeight: -0.25, // lower months-of-inventory => hotter
    saleToListZWeight: 0.25, // higher sale/list ratio => hotter
    priceCutZWeight: -0.2, // higher price-cut share => colder
    scaleToRange: 30, // multiply composite z by this, then clamp to [-100, 100]
  },
  sellSpeedShift: {
    scaleToRange: 100,
  },
  inventoryPressure: {
    moiTrendWeight: 0.6,
    activeListingsTrendWeight: 0.4,
    scaleToRange: 1.5,
  },
  opportunity: {
    priceCutZWeight: 0.4,
    moiZWeight: 0.3,
    domZWeight: 0.3,
    center: 50,
    scaleToRange: 20,
  },
  coolingRisk: {
    domTrendWeight: 0.3,
    moiTrendWeight: 0.3,
    priceTrendWeight: -0.2,
    salesTrendWeight: -0.2,
    center: 50,
    scaleToRange: 1.5,
  },
  buyerCompetition: {
    saleToListZWeight: 15,
    domZWeight: -15,
    priceCutZWeight: -10,
    pendingToNewZWeight: 10,
    center: 50,
  },
  confidence: {
    completenessWeight: 60,
    perSourceWeight: 15,
  },
} as const;

/** Score -> qualitative label thresholds, shared by every "-100..100 temperature-style" score. */
export const TEMPERATURE_THRESHOLDS = {
  hot: 30,
  warming: 8,
  cooling: -8,
  cold: -30,
};
